import React from 'react';
import Icon from '../../../components/AppIcon';
import { Field } from './BackgroundFields';
import {
  VIEWPORT_LIST,
  getComponentViewports,
  setComponentViewports,
  isComponentHidden,
} from '../utils/defaults';

export default function ViewportVisibilityFields({ comp, viewport = 'desktop', onChange }) {
  const visibleOn = getComponentViewports(comp);
  const hiddenOnCurrent =
    viewport !== 'desktop' ? comp?.[viewport]?.hidden === true : comp?.hidden === true;

  const toggleViewport = (vpId) => {
    const next = visibleOn.includes(vpId)
      ? visibleOn.filter((v) => v !== vpId)
      : [...visibleOn, vpId];
    if (next.length === 0) return;
    onChange(setComponentViewports(comp, next));
  };

  const toggleHiddenOnCurrent = () => {
    if (viewport === 'desktop') {
      onChange({ ...comp, hidden: !comp.hidden });
      return;
    }
    const vp = comp[viewport] || {};
    onChange({
      ...comp,
      [viewport]: { ...vp, hidden: !vp.hidden },
    });
  };

  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-border bg-muted/15 px-3 py-2.5 text-xs text-muted-foreground leading-relaxed">
        <Icon name="MonitorSmartphone" size={14} className="inline mr-1.5 -mt-0.5" />
        Choisissez sur quels écrans ce composant apparaît. Vous pouvez avoir des composants
        différents sur mobile, tablette et ordinateur.
      </div>

      <Field label="Afficher sur">
        <div className="flex flex-wrap gap-2">
          {VIEWPORT_LIST.map((vp) => {
            const active = visibleOn.includes(vp.id);
            return (
              <button
                key={vp.id}
                type="button"
                onClick={() => toggleViewport(vp.id)}
                className={`flex items-center gap-1.5 px-3 py-2 rounded-lg border text-xs font-medium transition-smooth ${
                  active
                    ? 'bg-primary/10 border-primary/40 text-primary'
                    : 'bg-background border-border text-muted-foreground hover:border-primary/30'
                }`}
              >
                <Icon
                  name={
                    vp.id === 'mobile'
                      ? 'Smartphone'
                      : vp.id === 'tablet'
                        ? 'Tablet'
                        : 'Monitor'
                  }
                  size={14}
                />
                {vp.label}
              </button>
            );
          })}
        </div>
      </Field>

      <Field
        label={`Masquer sur ${VIEWPORT_LIST.find((v) => v.id === viewport)?.label || viewport}`}
      >
        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <input
            type="checkbox"
            checked={hiddenOnCurrent}
            onChange={toggleHiddenOnCurrent}
            className="rounded border-border"
          />
          <span className="text-muted-foreground">
            {hiddenOnCurrent
              ? 'Masqué sur cet écran (toujours visible dans l’éditeur en pointillés)'
              : 'Visible sur cet écran'}
          </span>
        </label>
      </Field>

      {visibleOn.length < 3 ? (
        <p className="text-[11px] text-muted-foreground">
          Visible uniquement sur :{' '}
          {visibleOn
            .map((id) => VIEWPORT_LIST.find((v) => v.id === id)?.label || id)
            .join(', ')}
          .
        </p>
      ) : null}

      {isComponentHidden(comp, viewport) ? (
        <p className="text-[11px] text-amber-700 dark:text-amber-400">
          Ce composant est masqué sur l’écran actuellement sélectionné dans l’éditeur.
        </p>
      ) : null}
    </div>
  );
}
